// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"744":"99cb6652","4976":"99cb6652"}[chunkId] + ".chunk.css";
};